import { formatGuidePhaseLabel, getGuideRoleLabel } from '../../app/helpers/specialistGuideFilterHelper';
import {
  getAllModulesTone,
  getGuideModuleTone,
  getGuidePhaseTone,
  getGuideRoleTone
} from '../../app/helpers/specialistGuideColorHelper';

export const GuideToneBadge = ({ tone, children, title }) => (
  <span
    className="sg-badge"
    style={{
      background: tone.bg,
      color: tone.fg,
      border: `1px solid ${tone.border}`
    }}
    title={title || ''}
  >
    {children}
  </span>
);

export const GuideRoleBadges = ({ roles = [], t }) => (
  <>
    {(roles || []).map((role) => {
      const label = getGuideRoleLabel(role, t);
      return (
        <GuideToneBadge
          key={role.catalogrole_id || role.id || label}
          tone={getGuideRoleTone(role)}
          title={label}
        >
          {label}
        </GuideToneBadge>
      );
    })}
  </>
);

export const GuidePhaseBadge = ({ phase }) => {
  const label = formatGuidePhaseLabel(phase);
  if (!label) return null;
  return (
    <GuideToneBadge tone={getGuidePhaseTone(phase)} title={label}>
      {label}
    </GuideToneBadge>
  );
};

export const GuideModuleBadges = ({ modules = [], appliesToAll = false, t }) => {
  if (appliesToAll) {
    return (
      <GuideToneBadge tone={getAllModulesTone()} title={t('specialistGuides.fields.allModules')}>
        {t('specialistGuides.fields.allModules')}
      </GuideToneBadge>
    );
  }
  return (
    <>
      {(modules || []).map((moduleItem) => {
        const label = moduleItem.abbreviation || moduleItem.name || moduleItem.key;
        return (
          <GuideToneBadge
            key={moduleItem.catalogmodule_id || moduleItem.id || label}
            tone={getGuideModuleTone(moduleItem)}
            title={moduleItem.name || label}
          >
            {label}
          </GuideToneBadge>
        );
      })}
    </>
  );
};

export const SpecialistGuideMetaBadges = ({
  roles = [],
  phase,
  modules = [],
  appliesToAll = false,
  t,
  showRoles = true,
  showPhase = true,
  showModules = true
}) => (
  <div className="d-flex flex-wrap gap-1">
    {showRoles ? <GuideRoleBadges roles={roles} t={t} /> : null}
    {showPhase ? <GuidePhaseBadge phase={phase} /> : null}
    {showModules ? <GuideModuleBadges modules={modules} appliesToAll={appliesToAll} t={t} /> : null}
  </div>
);

export const SpecialistGuideColorLegend = ({ t, roles = [], modules = [] }) => (
  <div className="small">
    <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
      <span className="sg-legend-label">{t('specialistGuides.fields.roles')}</span>
      <GuideRoleBadges roles={roles} t={t} />
    </div>
    <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
      <span className="sg-legend-label">{t('specialistGuides.fields.phase')}</span>
      <GuidePhaseBadge phase="FASE_1_PROGRAMACION_PREVIA" />
      <GuidePhaseBadge phase="FASE_2_EXPLORACION" />
      <GuidePhaseBadge phase="FASE_3_RELEVAMIENTO" />
      <GuidePhaseBadge phase="FASE_4_LIMPIEZA_DATOS" />
      <GuidePhaseBadge phase="FASE_5_EDICION" />
      <GuidePhaseBadge phase="FASE_6_ACTUALIZACION" />
    </div>
    <div className="d-flex flex-wrap align-items-center gap-2">
      <span className="sg-legend-label">{t('specialistGuides.fields.modules')}</span>
      <GuideModuleBadges modules={modules} t={t} />
    </div>
  </div>
);

export const GuideColorDot = ({ tone }) => (
  <span className="sg-swatch me-1" style={{ background: tone.accent, border: `1px solid ${tone.border}` }} />
);
